// export const axiosAddress = "http://localhost:5000"

export const axiosAddress = "https://citysoflex.herokuapp.com"